import { createPinia } from "pinia";
import useProductDataStore from "./productDataStore.mjs";
import useProductPageStore from "./productPageStore.mjs";
import useProductAppPropsStore from "./productAppPropsStore.mjs";
import useProductMessagesStore from "./productMessagesStore.mjs";
import useProductAnalyticsStore from "./productAnalyticsStore.mjs";
import useProductMediaCenterStoreStore from "./productMediaCenterStore.mjs";
import useProductBuyBoxStore from "./productBuyBoxStore.mjs";
import useProductReviewsStore from "./productReviewsStore.mjs";
function initializePinia(app, model) {
  const pinia = createPinia();
  app.use(pinia);
  const {
    product,
    appProps,
    messages,
    analytics,
    previewMode
  } = model;
  pinia.state.value = {
    productAnalyticsStore: { analytics },
    productDataStore: { product, previewMode },
    productAppPropsStore: { appProps },
    productMessagesStore: { messages }
  };
  useProductDataStore(pinia);
  useProductPageStore(pinia);
  useProductAppPropsStore(pinia);
  useProductMessagesStore(pinia);
  useProductAnalyticsStore(pinia);
  useProductMediaCenterStoreStore(pinia);
  useProductBuyBoxStore(pinia);
  useProductReviewsStore(pinia);
}
export {
  initializePinia as default
};
//# sourceMappingURL=initializeStores.mjs.map
